import type { ReadOnlyUserOptionsType } from "owa-service/lib/ReadOnlyTypes";
import { action } from "satcheljs";
import type TimeZoneOffsetsType from "owa-service/lib/contract/TimeZoneOffsetsType";
import type RecursiveReadOnly from "owa-service/lib/RecursiveReadOnly";

export interface InitializeOwaDateTimeStoreActionMessage {
    DateFormat: string | undefined;
    TimeFormat: string | undefined;
    TimeZone: string | undefined;
    MailboxTimeZoneOffset: RecursiveReadOnly<TimeZoneOffsetsType[] | undefined>;
}
export const initializeOwaDateTimeStore: (options: Pick<ReadOnlyUserOptionsType, "DateFormat" | "TimeFormat" | "TimeZone" | "MailboxTimeZoneOffset"> | undefined) => InitializeOwaDateTimeStoreActionMessage = action("initializeOwaDateTimeStore", (options: Pick<ReadOnlyUserOptionsType, "DateFormat" | "TimeFormat" | "TimeZone" | "MailboxTimeZoneOffset"> | undefined): InitializeOwaDateTimeStoreActionMessage => {
    options = options || {};
    return {
        DateFormat: options.DateFormat,
        TimeFormat: options.TimeFormat,
        TimeZone: options.TimeZone,
        MailboxTimeZoneOffset: options.MailboxTimeZoneOffset,
    };
});
